import { useEffect, useState } from 'react';
import './ToastNotification.css';

interface ToastNotificationProps {
  message: string;
  isVisible: boolean;
  onHide: () => void;
  duration?: number;
  type?: 'success' | 'error';
}

export function ToastNotification({ message, isVisible, onHide, duration = 2000, type = 'success' }: ToastNotificationProps) {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsExiting(false);
      const timer = setTimeout(() => {
        setIsExiting(true);
        setTimeout(onHide, 300); // Wait for exit animation
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onHide, duration]);

  if (!isVisible && !isExiting) return null;

  const icon = type === 'error' ? '⚠️' : '✓';

  return (
    <div className={`toast-notification ${isExiting ? 'exiting' : ''} ${type === 'error' ? 'toast-error' : ''}`}>
      <div className="toast-content">
        <span className="toast-icon">{icon}</span>
        <span className="toast-message">{message}</span>
      </div>
    </div>
  );
}